import type { TFunction } from "i18next";

export interface SurveyQuestionTypeOption {
  value: SurveyQuestionType;
  label: string;
  icon: string;
}

export const SURVEY_QUESTION_TYPE_KEYS = [
  { value: "short_answer", labelKey: "surveys.question_types_short_answer", icon: "📝" },
  { value: "long_answer", labelKey: "surveys.question_types_long_answer", icon: "📄" },
  { value: "multiple_choice", labelKey: "surveys.question_types_multiple_choice", icon: "🔘" },
  { value: "multiple_answer", labelKey: "surveys.question_types_multiple_answer", icon: "☑️" },
  { value: "rating", labelKey: "surveys.question_types_rating", icon: "⭐" },
  { value: "scale", labelKey: "surveys.question_types_scale", icon: "📊" },
  { value: "date", labelKey: "surveys.question_types_date", icon: "📅" },
  { value: "time", labelKey: "surveys.question_types_time", icon: "🕐" },
  { value: "datetime", labelKey: "surveys.question_types_datetime", icon: "📅🕐" },
  { value: "file_upload", labelKey: "surveys.question_types_file_upload", icon: "📎" },
  { value: "email", labelKey: "surveys.question_types_email", icon: "📧" },
  { value: "phone", labelKey: "surveys.question_types_phone", icon: "📞" },
  { value: "number", labelKey: "surveys.question_types_number", icon: "🔢" },
  { value: "yes_no", labelKey: "surveys.question_types_yes_no", icon: "✅❌" },
  { value: "dropdown", labelKey: "surveys.question_types_dropdown", icon: "📋" },
  { value: "multiple_choice_grid", labelKey: "surveys.question_types_multiple_choice_grid", icon: "🔲" },
  { value: "checkbox_grid", labelKey: "surveys.question_types_checkbox_grid", icon: "☑️🔲" },
] as const;

export type SurveyQuestionType =
  (typeof SURVEY_QUESTION_TYPE_KEYS)[number]["value"];

export const getSurveyQuestionTypes = (t: TFunction): SurveyQuestionTypeOption[] =>
  SURVEY_QUESTION_TYPE_KEYS.map((type) => ({
    value: type.value,
    label: t(type.labelKey),
    icon: type.icon,
  }));
